// extracted by mini-css-extract-plugin
export default {"logo-title":"_329w0zugHKIV0zoXZcu3vf","logo-container":"_3Z3Ma_NQv__e-XHDBsysh1","logo-img":"_3gp4K2wGalyUucbt_2oif3"};